import React from 'react';
import { connect } from 'react-redux';

import BaseMainContent from '../../../components/layOut/baseContentMain/index';
import BaseContent from '../../../components/layOut/baseContent/index';
import BaseContentSider from '../subMenuContent/index';

class CommonContent extends React.Component {
  componentDidMount() { }

  render() {
    const { children, pathname, spa = false } = this.props;
    return (
      <BaseContent>
        {spa ? null : (<BaseContentSider pathname={pathname} />)}
        <BaseMainContent>{children}</BaseMainContent>
      </BaseContent>
    );
  }
}

const mapStateToProps = state => {
  return {
    pathname: state.routing.locationBeforeTransitions.pathname,
  };
};

export default connect(mapStateToProps)(CommonContent);
